<div class="action-buttons">
  <button
    #toggleButton
    psUiButton
    class="dropdown-button"
    data-boundary="viewport"
    [ngClass]="[
      (loading && 'loading') || '',
      dropdown,
      background,
      dropdownToggle
    ]"
    (click)="toggle()"
    (keydown)="focusItems($event, true)"
    (mousedown)="startClick()"
    (mouseup)="endClick()"
    (mouseout)="endClick()"
    [disabled]="disabled"
    data-e2e-label
    type="button"
  >
    <div class="button-content">
      <div class="button-label" [ngClass]="[textAlignment]">
        <div *ngIf="showFlag" class="d-inline-block">
          <ps-ui-flag [countryCode]="getFlagCountryCode()"></ps-ui-flag>
        </div>
        <span class="dropdown-button-label">
          {{
            truncateWord && getLabel().length > 15
              ? (getLabel() | slice : 0 : 15) + '...'
              : getLabel()
          }}
          <span
            *ngIf="getFlagLanguageCode()"
            class="p-1 fw-bold language-icon"
            >{{ getFlagLanguageCode() | uppercase }}</span
          >
          <span
            class="indicator-status-container"
            *ngIf="
              (indicator || showClearStateButton) &&
              (selected.length > 0 ||
                (enableSearch && searchInput?.nativeElement.value !== ''))
            "
          >
            <span class="indicator" *ngIf="indicator">
              {{ indicatorCounter() }}
            </span>
            <span
              class="clear-state icon-{{ clearStateButtonColor }}"
              *ngIf="showClearStateButton"
            >
              <i
                class="fa fa-times-circle"
                (click)="updateState()"
                aria-hidden="true"
                title="clear filter"
              ></i>
            </span>
          </span>
        </span>
        <div class="text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <span *ngIf="selectIcon" class="dropdown-button-icon" (click)="toggle()">
        <ng-container [ngTemplateOutlet]="selectIcon.template"></ng-container>
      </span>
    </div>
  </button>
</div>
<div class="dropdown">
  <!--
      this only gets focus when shift+tab from search input
      so when get back from search we understand the user wants
      to close the dropdown or focus another element
    -->
  <cdk-virtual-scroll-viewport
    [itemSize]="itemHeight"
    #scrollViewport
    [style.height]="scrollViewportHeight + 'px'"
    class="dropdown-menu user_list_dropdown_menu"
    [class.show]="isOpen"
    [class.dropup-menu]="dropup"
    (focus)="closeFocus()"
  >
    <div
      class="input-group input-group-sm"
      *ngIf="enableSearch"
      #searchContainer
    >
      <span class="input-group-text">
        <i class="fa fa-search" aria-hidden="true"></i>
      </span>
      <input
        type="text"
        class="form-control"
        placeholder="Search"
        [formControl]="searchTextControl"
        (keydown)="focusItems($event, false, true)"
        (focus)="scrollUp()"
        #searchInput
      />
      <button
        *ngIf="clearSearch"
        class="btn btn-outline-default dropdown-input-decorators"
        type="button"
        (click)="emptySearch()"
        (keydown)="focusItems($event, false, true)"
      >
        <i class="fa fa-times-circle" aria-hidden="true"></i>
      </button>
    </div>

    <div
      class="btn-group btn-group-sm w-100"
      role="group"
      *ngIf="multi && !action"
      #multiSelectContainer
    >
      <button
        psUiButton
        [outline]="true"
        [size]="'small'"
        class="p-0"
        [class.active]="allItemsSelected"
        type="button"
        (click)="selectAll()"
      >
        <i class="fa fa-check" aria-hidden="true"></i>
        All
      </button>
      <button
        psUiButton
        [outline]="true"
        [size]="'small'"
        class="p-0"
        [class.active]="!selectedItemsCount"
        type="button"
        (click)="selectNone()"
      >
        <i class="fa fa-times" aria-hidden="true"></i>
        None
      </button>
    </div>
    <div
      *ngIf="action && action.enabled"
      class="btn-group btn-group-sm w-100"
      role="group"
    >
      <ng-container [ngTemplateOutlet]="action.template"></ng-container>
    </div>
    <ng-container *ngIf="dropdownItems">
      <div
        *ngIf="noItemMessage && !dropdownItems.length"
        class="new-item-message"
        id="new-item-message"
        #noItemMsgContainer
      >
        <span>
          {{ noItemMessage }}
        </span>
      </div>
      <ng-container
        *cdkVirtualFor="
          let item of searchDropdownItems
            ? (dropdownItems
              | psUiSearch : searchTextControl.value : searchByKeys)
            : dropdownItems;
          let i = index
        "
      >
        <div class="group" *ngIf="groups[i]">
          <p>{{ groups[i] }}</p>
          <hr />
        </div>
        <ps-ui-select-dropdown-item
          [clickedItem]="item"
          (clicked)="selectItem($event)"
          (selectNextItem)="focusNext(i)"
          (selectPreviousItem)="focusPrevious(i)"
          (exitItems)="closeFocus()"
          class="template-item"
        >
          <span id="multi-cb-{{ i }}" *ngIf="multi">
            <input
              id="item-{{ i }}"
              type="checkbox"
              class="form-check-input"
              [checked]="findSelectedItemIndex(item) > -1"
              attr.data-e2e="country-{{ item[idField] }}"
            />
          </span>
          <i
            [class]="iconClass"
            class="folder-icon"
            aria-hidden="true"
            *ngIf="icon && !item[mcIconIdentifier]"
          ></i>
          <img
            src="/assets/image/multi-country-icon.png"
            class="multi-country-icon"
            *ngIf="item[mcIconIdentifier]"
            alt="Multicountry Icon"
          />
          <div *ngIf="showFlag" class="d-inline-block">
            <ps-ui-flag
              [countryCode]="item[flagCountryCodeField]"
              [attr.data-e2e]="
                item[flagCountryCodeField] && item[flagLanguageCodeField]
                  ? 'localization-dropdown-' +
                    item[flagCountryCodeField] +
                    '-' +
                    item[flagLanguageCodeField]
                  : null
              "
            >
            </ps-ui-flag>
          </div>
          <span class="p-0 px-1">{{ item[field] }}</span>
          <span
            *ngIf="item[flagLanguageCodeField]"
            class="p-1 fw-bold language-icon"
            >{{ item[flagLanguageCodeField] | uppercase }}</span
          >
          <span
            *ngIf="icon"
            class="text-muted float-end"
            title="{{
              item[mcIconIdentifier]
                ? 'Multi-country template'
                : 'Single country template'
            }}"
            >{{ item[mcIconIdentifier] ? 'MC' : 'SC' }}</span
          >
          <span class="pull-right" *ngIf="spanField">
            {{ item[spanField] }}
          </span>
        </ps-ui-select-dropdown-item>
      </ng-container>
      <div *ngIf="newTextInput" class="new-input-list" id="new-input-list">
        <span
          (click)="changeTextBox()"
          class="dropdown-item dropdown-item-selectable"
          *ngIf="newTextSelectionType === 'label' && !newText"
          id="new-input-icon-span"
          #newFooterInputContainer
        >
          <img
            src="/assets/image/add-template-icon.png"
            class="add-template-icon"
            alt="+"
            id="new-input-icon"
            #newinputicon
          />
          {{ newInputLabel }}
        </span>
        <span
          *ngIf="newTextSelectionType === 'button' && !newText"
          class="d-flex justify-content-around test"
          #newFooterInputContainer
        >
          <button
            type="button"
            psUiButton
            color="secondary"
            class="btn footer-button"
            (click)="changeTextBox(); $event.stopPropagation()"
          >
            {{ newInputLabel }}
          </button>
        </span>
        <span
          *ngIf="newText"
          class="dropdown-item dropdown-item-selectable footer-input-text"
          id="new-input-list"
        >
          <i
            class="fa fa-times-circle"
            aria-hidden="true"
            (click)="changeTextBox()"
            id="new-input-remove"
            #newinputemove
          ></i
          ><input
            type="text"
            placeholder="{{ newTextInputPlaceHolder }}"
            [formControl]="inputItem"
            #templateNameInput
            (keyup)="removeEmptySpace()"
          />
          <button
            color="secondary"
            (click)="saveFooterItem()"
            id="footer-button"
            #footerbutton
          >
            <i
              class="fa fa-check"
              aria-hidden="true"
              id="footer-button-check"
              #footerbuttoncheck
            ></i>
          </button>
        </span>
      </div>
      <div *ngIf="addNewItem" class="add-new-item" id="add-new-item">
        <span
          class="dropdown-item dropdown-item-selectable"
          (click)="addNoMatchItem(addNewItemDropDown)"
        >
          <img
            src="/assets/image/add.png"
            class="add-template-icon"
            alt="+"
            id="new-input-icon"
            #newFooterInputContainer
          />
          Add New Item
        </span>
      </div>
    </ng-container>
  </cdk-virtual-scroll-viewport>
</div>
